module.exports = __webpack_public_path__ + "img/ill_spot_miscellaneous.6a89dd33.svg";